<template>
  <!-- page-wrapper Start-->
  <div class="page-wrapper compact-wrapper" id="pageWrapper">
    <div class="page-body-wrapper">
      <div class="page-body">
        <!-- Breadcrumb & Title -->
        <div class="container-fluid">
          <div class="page-title">
            <div class="row">
              <div class="col-12 col-sm-6">
                <h3>Customer List</h3>
              </div>
              <div class="col-12 col-sm-6">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                    <a class="home-item" href="/"><i data-feather="home"></i></a>
                  </li>
                  <li class="breadcrumb-item">Dashboard</li>
                  <li class="breadcrumb-item active">Customer List</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <!-- Breadcrumb & Title -->

        <!-- Container-fluid starts-->
        <div class="container-fluid list-products">
          <div class="row">
            <!-- Data table -->
            <div class="col-sm-12 col-lg-12">
              <div class="card">
                <div class="card-header pb-0">
                  <h5>List</h5>
                  <span>Customer List</span>
                </div>
                <div class="card-body">
                  <div class="table-responsive product-tabl">
                    <table class="display w-100" id="customerListTBL">
                      <thead>
                        <tr align="center">
                          <th>#</th>
                          <th>Customer Id</th>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Phone</th>
                          <th>Details</th>
                          <th>Active Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr align="center" v-for="(item, index) in customerList" :key="index">
                          <td>{{ index + 1 }}</td>
                          <td>{{ item.customer_id }}</td>
                          <td>{{ item.name }}</td>
                          <td>{{ item.email }}</td>
                          <td>{{ item.phone }}</td>
                          <td>
                            <div class="media-body switch-sm" v-if="item.status === 1"
                              @click.prevent="changeStatus(item.id)">
                              <label class="switch">
                                <input type="checkbox" checked /><span class="switch-state"></span>
                              </label>
                            </div>
                            <div class="media-body switch-sm" v-if="item.status === 2"
                              @click.prevent="changeStatus(item.id)">
                              <label class="switch">
                                <input type="checkbox" /><span class="switch-state"></span>
                              </label>
                            </div>
                          </td>
                          <td>
                            <router-link :to="'/customer/details/' + item.id" class="btn btn-info btn-sm" type="button"
                              data-original-title="btn btn-danger btn-xs" title="" @click.prevent="updateType(item.id)">
                              Details
                            </router-link>
                          </td>

                          <td>


                            <button class="btn btn-danger btn-sm" type="button"
                              data-original-title="btn btn-danger btn-xs" title="" @click.prevent="deleteType(item.id)">
                              Delete
                            </button>
                            <router-link v-if="item.status === 1" :to="'/customer/edit/' + item.id"
                              class="btn btn-primary btn-sm" type="button" data-original-title="btn btn-danger btn-xs"
                              title="" @click.prevent="updateType(item.id)">
                              Edit
                            </router-link>
                            <router-link :to="'/customer-service/' + item.id" class="btn btn-info btn-sm" type="button"
                              data-original-title="btn btn-secondary btn-xs" title=""
                              @click.prevent="updateType(item.id)">
                              Services
                            </router-link>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Container-fluid starts-->
      </div>
    </div>
  </div>
</template>

<script>
import "jquery/dist/jquery.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";

import $ from "jquery";
import customerAPI from "../../services/customer.API.js";

export default {
  name: "CustomerList",
  components: {},
  data() {
    return {
      title: "",
      price: "",
      customerList: [],
      districtList: [],
      isCreate: true,
      update: {
        id: "",
        title: "",
        // active_status: '',
      },
      selectedDistrict: null,
    };
  },
  methods: {
    // district list
    getList() {
      customerAPI.getList().then(
        (response) => {
          this.customerList = response.data.data;
          console.log(response.data.data);
        },
        (err) => {
          if (err.response.data.success === false) {
            this.customerList = [];
          }
        }
      );
    },

    // delete
    deleteType(id) {
      if (id) {


        this.$swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.isConfirmed) {
            customerAPI.deleteCustomer(id).then(
              (response) => {
                this.$moshaToast(response.data.message, {
                  type: "success",
                  position: "top-right",
                  showIcon: true,
                });
                // get all connection type
                customerAPI.getList().then((response) => {
                  this.customerList = response.data.data;
                });
              },
              (err) => {
                this.$moshaToast(err.response.data.message, {
                  type: "danger",
                  position: "top-right",
                  showIcon: true,
                });
              }
            );
          }
        });


      } else {
        this.$moshaToast("Please select service type", {
          type: "danger",
          position: "top-right",
          showIcon: true,
        });
      }
    },

    // change status
    changeStatus(id) {
      if (id) {
        customerAPI.changeStatus(id).then(
          (response) => {
            this.$moshaToast(response.data.message, {
              type: "success",
              position: "top-right",
              showIcon: true,
            });
            // get all connection type
            customerAPI.getList().then((response) => {
              this.customerList = response.data.data;
            });
          },
          (err) => {
            this.$moshaToast(err.response.data.message, {
              type: "danger",
              position: "top-right",
              showIcon: true,
            });
          }
        );
      } else {
        this.$moshaToast("Please select connection type", {
          type: "danger",
          position: "top-right",
          showIcon: true,
        });
      }
    },
  },
  mounted() {
    //   list
    customerAPI.getList().then(
      (response) => {
        this.customerList = response.data.data;
        setTimeout(() => {
          $("#customerListTBL").DataTable({
            lengthMenu: [
              [10, 25, 50, -1],
              [10, 25, 50, "All"],
            ],
            pageLength: 10,
            info: false,
            targets: "no-sort",
            bSort: false,
            order: [],
            bFilter: true,
            bInfo: false,
            //   bLengthChange: false,
            bDestroy: true,
          });
        });
      },
      (err) => {
        this.$moshaToast(err.response.data.message, {
          type: "danger",
          position: "top-right",
          showIcon: true,
        });
      }
    );
  },
};
</script>

<style scoped>
.btn {
  margin: 5px;
}

th {
  text-align: center !important;
}

span.switch-state:before {
  background: #000 !important;
  margin-bottom: -2px !important;
}

span.switch-state {
  border: 2px solid #000 !important;
}
</style>
